module.exports = __webpack_public_path__ + "static/img/6832_phase_function_Paper_PointsHejduk_Prediction.fadaf34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6832_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2nXM
// module chunks = 0